$('document').ready(function () {
  var lastsearch = '';

  $('.sub-search').on('focus', function () {
    $('#search-alert').addClass('d-flex').removeClass('d-none');
  });

  $('.sub-search').on('focusout', function () {
    if ($('.sub-search').val().length <= 0) {
      $('#search-alert').addClass('d-none').removeClass('d-flex');
    }
  });

  $('.sub-search').on('keyup', function () {
    var currentsearch = $(this).val();
    $('.product').each(function () {
      var product = $(this);
      product.find('h5').each(function () {
        var title = $(this).html();
        product.hide();
        if (title.toLowerCase().search(currentsearch.toLowerCase()) >= 0) {
          product.show();
        }
      });
    });
  });

  $('.bought-products .btn-selected').on('click', function () {
    if($(this).hasClass('btn-active')) {
      $(this).parents('.table-row').find('.selected-note').removeClass('d-none');
    } else {
      $(this).parents('.table-row').find('.selected-note').addClass('d-none');
    }
  });

  $('.bought-products .selected-note textarea').on('change', function () {
    var post_data = {
      'quantity': '-',
      'note': $(this).val()
    };

    $.post('/ajax/selected/add/' + $(this).data('product-id'), post_data);
  });
});
